import { createSlice } from "@reduxjs/toolkit";

const initialState = { filter: [], search: "" };

// Filter slice to handle the filter and search state
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    // When the app is loaded to initialize the filter state
    initFilter: (state, action) => {
      const projects = action.payload;

      // If there are projects, map through them and add them to the filter state
      if (projects.length > 0) {
        projects.map((project) =>
          state.filter.includes(project.projectName)
            ? null
            : state.filter.push(project.projectName)
        );
      }
    },

    //   When the user clicks on a project to filter the tasks
    addFilter: (state, action) => {
      state.filter = [...state.filter, action.payload];
    },

    // When the user clicks on a project to remove the filter
    removeFilter: (state, action) => {
      state.filter = state.filter.filter((data) => data !== action.payload);
    },

    // When the user types in the search bar
    searching: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { addFilter, removeFilter, initFilter, searching } =
  filterSlice.actions;
export default filterSlice.reducer;
